// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__rzJS7","linkContainer":"Header_linkContainer__Csg4x","logo":"Header_logo__1wQYZ","text":"Header_text__wSajO"};